import { createStore } from 'vuex';
import ExamModule from "vue/applications/frontend/store/modules/exam";
import FilterModule from "vue/applications/frontend/store/modules/filter";
import GonModule from "vue/applications/frontend/store/modules/gon";
import VuexHooks from "vue/applications/frontend/store/hooks/all";
import ImportAll from "utils/import_all";

// Load all vue-components
const components: { [key: string]: any } = {};
const routes: { [key: string]: any } = {};
ImportAll(components, require.context("./frontend/components/", true, /\.vue$/));

const FrontendApplication: VueApplication = {
  store() {
    const store = createStore({
      modules: {
        exam: ExamModule,
        filter: FilterModule,
        gon: GonModule,
      },
    });

    // Run all the hooks that register once with the store
    for (const hook of VuexHooks) {
      hook(store);
    }
    return store;
  },
  initialize(app) {
     // Load all components, if the application is loaded (see initialize_vue_app)
    Object.keys(routes).forEach((key) => app.component(key, routes[key]));
    Object.keys(components).forEach((key) => app.component(key, components[key]));
  }
};

export default FrontendApplication;

